import { useState } from 'react';
import api from '../api/client';
import { studentLabel } from '../utils/studentLabel';

/**
 * Подпись ученика + карандаш для своего имени (видно только преподавателю).
 */
export default function StudentAliasCell({
  studentId,
  student,
  onUpdated,
  showUsername = true,
  as = 'span',
}) {
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const label = studentLabel(student);
  const username = (student?.username || '').trim();
  const Tag = as === 'h1' ? 'h1' : 'span';

  function startEdit(e) {
    e.stopPropagation();
    setDraft((student?.alias || '').trim());
    setError('');
    setEditing(true);
  }

  function cancel(e) {
    e?.stopPropagation?.();
    setEditing(false);
    setError('');
  }

  async function save(e) {
    e.preventDefault();
    e.stopPropagation();
    setSaving(true);
    setError('');
    try {
      const res = await api.patch(`/teacher/students/${studentId}/alias/`, {
        alias: draft.trim(),
      });
      onUpdated?.(res.data.alias ?? '');
      setEditing(false);
    } catch (err) {
      const msg = err.response?.data?.alias;
      setError(
        Array.isArray(msg)
          ? msg[0]
          : (typeof msg === 'string' ? msg : 'Не удалось сохранить имя.'),
      );
    } finally {
      setSaving(false);
    }
  }

  if (editing) {
    return (
      <form className="student-alias-edit" onClick={(e) => e.stopPropagation()} onSubmit={save}>
        <input
          type="text"
          className="form-input"
          autoFocus
          value={draft}
          onChange={(e) => setDraft(e.target.value)}
          placeholder="Как называть (только вам)"
          aria-label="Своё имя ученика"
          maxLength={80}
        />
        {error && <div className="student-alias-error">{error}</div>}
        <div className="student-alias-edit-actions">
          <button type="submit" className="btn btn-xs btn-primary" disabled={saving}>
            {saving ? '…' : 'Сохранить'}
          </button>
          <button type="button" className="btn btn-xs btn-outline" onClick={cancel} disabled={saving}>
            Отмена
          </button>
        </div>
      </form>
    );
  }

  return (
    <div className="student-alias">
      <Tag className="student-alias-label">{label || 'Ученик'}</Tag>
      {showUsername && username && (
        <span className="text-secondary student-alias-username">@{username}</span>
      )}
      <button
        type="button"
        className="btn btn-xs btn-outline student-alias-edit-btn"
        onClick={startEdit}
        title={student?.alias ? 'Изменить своё имя ученика' : 'Задать своё имя ученика'}
        aria-label="Изменить своё имя ученика"
      >
        <i className="fa-solid fa-pencil" aria-hidden />
      </button>
    </div>
  );
}
